import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";

// Rendered inside the detail page's tab panel, which already names it — no
// heading of its own.
export const ExpensesSection = ({ purchaseInvoiceExpenses }) => {
  const columns = [
    {
      field: "outletChartOfAccount",
      headerName: "Akun",
      flex: 3,
      valueGetter: (value, row) => {
        const account = row.outletChartOfAccount;
        return account ? `${account.code} - ${account.name}` : "";
      },
    },
    {
      field: "amount",
      headerName: "Nominal",
      flex: 1,
      type: "number",
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "returnedAmount",
      headerName: "Retur",
      flex: 1,
      type: "number",
      valueGetter: (_, row) => row.returnedAmount || 0,
      valueFormatter: (value) => (value > 0 ? formatNumber(value) : "-"),
    },
    {
      field: "note",
      headerName: "Catatan",
      flex: 2,
      valueGetter: (_, row) => row.note || "-",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={purchaseInvoiceExpenses || []}
      disableRowSelectionOnClick
      hideFooter
    />
  );
};

ExpensesSection.propTypes = {
  purchaseInvoiceExpenses: PropTypes.array,
};
